module.exports = __webpack_public_path__ + "static/img/8.583289a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/8.jpg
// module id = EZzw
// module chunks = 1